import PendingCashfreeTransactionsTable from './components/PendingCashfreeTransactionsTable';
import UseAccountStore from '../../../stores/DataStore';
import React, {useCallback, useEffect, useState} from 'react';
import Widget from '../../../components/widget/Widget';
import {HiOutlineCash} from 'react-icons/hi';
import {defaultDateFormatStr, formatCurrency} from '../../../stores/JSHelper';
import UseCashfreeTransactionStore from '../../../stores/CashfreeTransactionStore';
import Spinner from '../../../components/spinner';

const PendingCashfreeTransactions = () => {
  const {loading, refresh, response, psp, setPsp} = UseCashfreeTransactionStore();
  const {account} = UseAccountStore();
  const [includeSuccess, setIncludeSuccess] = useState(false);

  useEffect(() => {
    (async () => {
      await refresh();
    })();
  }, [account, refresh]);

  const onIncludeSuccessChange = useCallback((includeSuccess: boolean) => {
    setIncludeSuccess(includeSuccess);
    refresh(includeSuccess);
  }, [refresh]);

  if (!loading && !response) {
    return <Spinner/>;
  }

  const widgets = [
    {title: 'Start Date', subtitle: `${loading ? '-' : defaultDateFormatStr(response.startDate)}`},
    {title: 'End Date', subtitle: `${loading ? '-' : defaultDateFormatStr(response.endDate)}`},
    {title: 'Total Amount', subtitle: `${loading ? '-' : formatCurrency(response.totalAmount, 'INR')}`},
  ];

  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-6">
        {widgets.map((d) => {
          return <Widget icon={<HiOutlineCash className="h-7 w-7" />} title={d.title} subtitle={d.subtitle} key={d.title} />;
        })}
      </div>

      <div className="my-5">
        <div>
          {!loading && response && 
            <PendingCashfreeTransactionsTable 
              transactions={response.transactions}
              refresh={refresh}
              psp={psp}
              setPsp={setPsp}
              includeSuccess={includeSuccess}
              onIncludeSuccessChange={onIncludeSuccessChange}/>
            }
          {loading && <span>Loading...</span>}
        </div>
      </div>
    </div>
  );
};

export default PendingCashfreeTransactions;
